import CryptoJS from 'crypto-js/crypto-js'
import crypto from 'crypto';
import { JSEncrypt } from 'jsencrypt'
let mixin = {
	data() {
		return {
			
		}
	},
	methods:{
		/*获取MD5值*/
		getMd5(pass) {
			 let md5 = crypto.createHash("md5"); 
	   		 md5.update(pass); 
		     return md5.digest('hex');	
		},
		/*密码加密*/
		createServerPwd(pwd) {
			//对密码进行加盐加密，然后再进行公钥加密
			let _this = this;
			let salt = "nb_lbhf";  //salt通过API请求获得nb_lbhf
			let passMd5 ="";				
			passMd5 = _this.getMd5(pwd); 
			let passMd5Salt = _this.getMd5(passMd5.toUpperCase() + salt);
			passMd5Salt = passMd5Salt.toUpperCase();//转换成32位大写密文
			let encryptor = new JSEncrypt()  // 新建JSEncrypt对象
			encryptor.setPublicKey(publicKey)  // 设置公钥
			return encryptor.encrypt(passMd5Salt)  // 对密码进行加密
		}
	}
}

export default mixin = mixin;


// WEBPACK FOOTER //
// ./src/components/home/enPwd.js